import ROUTE_NAMES from './route-names.js'

const {
  checkout,
  checkoutRegistration,
  checkoutShipping,
  checkoutPayment,
  pageNotFound,
  product,
  demo,
  demoForm,
} = ROUTE_NAMES

export default [
  {
    path: `/${checkout}`,
    redirect: `/${checkout}/${checkoutRegistration}`,
    name: checkout,
    meta: { layout: 'SimpleLayout' },
    component: () => {
      return import(/* webpackChunkName: "checkout-v2" */ '@/views/Checkout.vue')
    },
    children: [
      {
        path: `${checkoutRegistration}`,
        name: checkoutRegistration,
        meta: { layout: 'SimpleLayout' },
        component: () => {
          return import(/* webpackChunkName: "registration" */ '@/views/Checkout/Registration.vue')
        },
      },
      {
        path: `${checkoutShipping}`,
        name: checkoutShipping,
        meta: { layout: 'SimpleLayout' },
        component: () => {
          return import(/* webpackChunkName: "shipping" */ '@/views/Checkout/Shipping.vue')
        },
      },
      {
        path: `${checkoutPayment}`,
        name: checkoutPayment,
        meta: { layout: 'SimpleLayout' },
        component: () => {
          return import(/* webpackChunkName: "payment" */ '@/views/Checkout/Payment.vue')
        },
      },
    ],
  },
  {
    path: `/${product}/:slug`,
    name: product,
    component: () => {
      return import(/* webpackChunkName: "product-page" */ '@/views/ProductPage.vue')
    },
  },
  {
    path: `/${demo}`,
    name: demo,
    component: () => {
      return import(/* webpackChunkName: "demo" */ '@/views/Demo.vue')
    },
    children: [
      {
        path: `${demoForm}`,
        name: demoForm,
        component: () => {
          return import(/* webpackChunkName: "demo-form" */ '@/views/demo/DemoForm.vue')
        },
      },
    ],
  },
  {
    path: '*',
    name: pageNotFound,
    meta: { layout: 'BlankLayout' },
    component: () => {
      return import(/* webpackChunkName: "page-not-found" */ '@/views/PageNotFound.vue')
    },
  },
]
